import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=d8fbdf5c&scoped=true"
import script from "./contact.vue?vue&type=script&lang=ts"
export * from "./contact.vue?vue&type=script&lang=ts"
import style0 from "./contact.vue?vue&type=style&index=0&id=d8fbdf5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fbdf5c",
  null
  
)

export default component.exports